// @ts-nocheck 793e23f9
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_upload_buttons'],
      sections: [addPanel.sections.getSections().developer.fileUploaderSection],
    };
  },
};
